import { render, staticRenderFns } from "./packingDetails.vue?vue&type=template&id=f1b1ddda&scoped=true&"
import script from "./packingDetails.vue?vue&type=script&lang=js&"
export * from "./packingDetails.vue?vue&type=script&lang=js&"
import style0 from "./packingDetails.vue?vue&type=style&index=0&id=f1b1ddda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b1ddda",
  null
  
)

export default component.exports